import { useSelector } from '@cbridge-utils/react-redux';
import { userIsManagerSelector } from '../_selectors/userIsManager.selector';

export const useIsReadOnly = () => (
  !useSelector(userIsManagerSelector)
);
